package com.neurobs.ccabserver.administrator.view

import com.neurobs.js.view.{CheckBox, Form, Text, TextBox}
import com.neurobs.js.dom.ElementFactory._
import com.neurobs.js.dom.DOMViewElement._
import com.neurobs.js.dom.ElementFactory
import org.scalajs.dom.html

object UserListView {
	private val boxWidth = 20
	private val formWidth = 40

	private def makeText = makeTextInput(boxWidth)

	case class CreateForm(form: Form, email: TextBox, firstName: TextBox, lastName: TextBox)

	def createForm(migrate: Boolean): CreateForm = {
		val email = makeText
		val firstName = makeText
		val lastName = makeText

		val form = makeForm(
			width = formWidth,
			title = if (migrate) "Migrate User" else "Create User",
			description = if (migrate) "A temporary password will be emailed to the migrated user." else "A temporary password will be emailed to the new user.",
			elements = Array(
				("Email:", email),
				("First Name:", firstName),
				("Last Name:", lastName)
			),
			useCancel = true,
			submitCaption = if (migrate) "Migrate" else "Create"
		)
		CreateForm(form, email = email, firstName = firstName, lastName = lastName)
	}

	case class ResetPasswordForm(form: Form, password: TextBox, passwordConfirm: TextBox)

	def resetPasswordForm(username: String): ResetPasswordForm = {
		val password = makePasswordInput(boxWidth)
		val passwordConfirm = makePasswordInput(boxWidth)
		val form = makeForm(
			width = formWidth,
			title = "Reset Password",
			description = s"Reset password for user '$username'.",
			elements = Array(
				("Password:", password),
				("Confirm Password:", passwordConfirm)
			),
			useCancel = true,
			submitCaption = "Reset"
		)
		ResetPasswordForm(form, password, passwordConfirm)
	}

	case class EditForm(form: Form, email: Text, firstName: TextBox, lastName: TextBox, accountAdmin: CheckBox, disabled: CheckBox)

	def editForm(): EditForm = {
		val email: html.Span = ElementFactory.makeText()
		val firstName = makeText
		val lastName = makeText
		val accountAdmin = makeCheckbox()
		val disabled = makeCheckbox()

		val form = makeForm(
			width = formWidth,
			title = "Edit User",
			description = "Update the user's profile and access settings.",
			elements = Array(
				("Email:", email),
				("First Name:", firstName),
				("Last Name:", lastName),
				("Account Admin:", accountAdmin.input),
				("Disabled:", disabled.input)
			),
			useCancel = true,
			submitCaption = "Update"
		)

		EditForm(form = form, email = email, firstName = firstName, lastName = lastName, accountAdmin = accountAdmin, disabled = disabled)
	}
}